import { render, staticRenderFns } from "./AttachmentChangeVisibilityDialog.vue?vue&type=template&id=77379cb7&"
import script from "./AttachmentChangeVisibilityDialog.vue?vue&type=script&lang=js&"
export * from "./AttachmentChangeVisibilityDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports